import {AxiosResponse} from "axios"
import {
    NewBuildingSpace,
    UpdateBuildingSpace,
    BuildingSpace,
    BuildingSpacesFilterOptions
} from "@/services/models/BuildingSpace";
import {PagedData} from "@/services/models/shared/PagedData";
import BimsHttpService from "@/services/BimsHttpService";

class BuildingSpaceService {

    /**
     * @description Returns a paged list of building spaces for a specific building.
     */
    getBuildingSpaces(buildingId: string, filter: BuildingSpacesFilterOptions
    ): Promise<PagedData<BuildingSpace>> {
        return BimsHttpService.get(`/buildings/${buildingId}/spaces`, {
            params: filter
        }).then((response: AxiosResponse<PagedData<BuildingSpace>>) => {
            return response.data as PagedData<BuildingSpace>;
        });
    }

    /**
     * @description Returns a paged list of building spaces.
     */
     getAllBuildingSpaces(filter: BuildingSpacesFilterOptions
      ): Promise<PagedData<BuildingSpace>> {
          return BimsHttpService.get('/buildings/spaces', {
              params: filter
          }).then((response: AxiosResponse<PagedData<BuildingSpace>>) => {
              return response.data as PagedData<BuildingSpace>;
          });
      }

    /**
     * @description Returns the building space with the specified id
     */
    getBuildingSpace(id: string): Promise<BuildingSpace> {
      return BimsHttpService.get(`/buildings/spaces/${id}`).then((response: AxiosResponse<BuildingSpace>) => {
        return response.data as BuildingSpace;
        });
    }

    /**
     *  @description Adds new building spaces for the specified building id
     */
    addBuildingSpaces(buildingId: string, buildingSpaces: Array<NewBuildingSpace>): Promise<string> {
        return BimsHttpService.post(`/buildings/${buildingId}/spaces`,
          buildingSpaces
        ).then(response => {
            return response.data
        });
    }

    /**
     * @description Updates the building space
     */
    updateBuildingSpace(id: string, buildingSpace: UpdateBuildingSpace): Promise<any> {
        return BimsHttpService.put(`/buildings/spaces/${id}`,
          buildingSpace
        )
    }

    /**
     * @description Deletes the building space
     */
    deleteBuildingSpace(id: string): Promise<any> {
        return BimsHttpService.delete(`/buildings/spaces/${id}`)
    }
}

export default new BuildingSpaceService();
